<template>
    <div class="file-uploader">
        <div v-for="(fileInput, index) in fileInputs" :key="index" class="file-input-wrapper">
            <v-file-input type="file" :ref="'fileInput' + index" @change="handleFileChange(index, $event)"
                accept="image/*, video/*" show-size @click:clear="removeFileInput(index)" :clearable="false" chips
                append-icon="mdi-close" @click:append="removeFileInput(index)" />

            <div v-if="fileInput.preview" class="preview">
                <img v-if="isImage(fileInput.file)" :src="fileInput.preview" alt="Preview" class="preview-image">
                <video v-else-if="isVideo(fileInput.file)" controls class="preview-video">
                    <source :src="fileInput.preview" :type="fileInput.file.type">
                </video>
            </div>
        </div>

        <v-btn @click="addFileInput" text color="primary">
            Agregar otro archivo
        </v-btn>
    </div>
</template>

<script>
export default {
    props: {
        clearFiles: {
            type: Number,
            default: 0 // Default value for clearing files
        },
        MAX_SIZE_IMAGE: {
            type: Number,
            default: 1 // Default value in MB
        },
        MAX_SIZE_VIDEO: {
            type: Number,
            default: 10 // Default value in MB
        },
        MAX_SIZE_ALL_FILES: {
            type: Number,
            default: 20 // Default value in MB
        },
        MAX_FILES: {
            type: Number,
            default: 5 // Default maximum number of files
        }
    },

    beforeMount() {
        this.clearAllFiles();
    },

    data() {
        return {
            fileInputs: [{
                file: null,
                preview: null
            }],
            maxSizeFileImage: this.MAX_SIZE_IMAGE * 1024 * 1024, // 1 MB
            maxSizeFileVideo: this.MAX_SIZE_VIDEO * 1024 * 1024, // 10 MB
            maxSizeAllFiles: this.MAX_SIZE_ALL_FILES * 1024 * 1024, // 20 MB
            maxFiles: this.MAX_FILES, // Máximo de archivos permitidos
        }
    },

    computed: {
        hasFiles() {
            return this.fileInputs.some(input => input.file !== null)
        }
    },

    watch: {
        clearFiles(newValue) {
            this.clearAllFiles(newValue);
        }
    },

    methods: {
        addFileInput() {
            this.fileInputs.push({
                file: null,
                preview: null
            })
        },

        removeFileInput(index) {
            this.fileInputs.splice(index, 1);
            this.$emit('filesImput', this.fileInputs);
        },

        handleFileChange(index, event) {
            const file = event
            if (!file) return

            // Validar tamaño del archivo de imagen
            if (this.isImage(file) && file.size > this.maxSizeFileImage) {
                this.$confirm({
                    message: `El archivo de imagen no puede exceder de ${this.maxSizeFileImage / 1024 / 1024} MB`,
                    button: {
                        yes: "Aceptar",
                    },
                    callback: (confirm) => {
                        if (confirm) {
                            this.$refs['fileInput' + index][0].reset()
                            this.fileInputs[index].file = null
                            this.fileInputs[index].preview = null
                        }
                    },
                });
                return
            }

            // Validar tamaño del archivo de video
            if (this.isVideo(file) && file.size > this.maxSizeFileVideo) {
                this.$confirm({
                    message: `El archivo de video no puede exceder los ${this.maxSizeFileVideo / 1024 / 1024} MB`,
                    button: {
                        yes: "Aceptar",
                    },
                    callback: (confirm) => {
                        if (confirm) {
                            this.$refs['fileInput' + index][0].reset()
                            this.fileInputs[index].file = null
                            this.fileInputs[index].preview = null
                        }
                    },
                });
                return
            }

            // Validar tamaño total de todos los archivos
            const totalSize = this.fileInputs.reduce((total, input) => {
                return total + (input.file ? input.file.size : 0)
            }, 0)

            if (totalSize + file.size > this.maxSizeAllFiles) {
                this.$confirm({
                    message: `El tamaño total de los archivos no puede exceder los ${this.maxSizeAllFiles / 1024 / 1024} MB`,
                    button: {
                        yes: "Aceptar",
                    },
                    callback: (confirm) => {
                        if (confirm) {
                            this.$refs['fileInput' + index][0].reset()
                            this.fileInputs[index].file = null
                            this.fileInputs[index].preview = null
                        }
                    },
                });

                return
            }

            // Validar número máximo de archivos
            if (this.fileInputs.length > this.maxFiles) {
                this.$confirm({
                    message: `No se pueden agregar más de ${this.maxFiles} archivos`,
                    button: {
                        yes: "Aceptar",
                    },
                    callback: (confirm) => {
                        if (confirm) {
                            this.$refs['fileInput' + index][0].reset()
                            this.fileInputs[index].file = null
                            this.fileInputs[index].preview = null
                        }
                    },
                });
                return
            }

            this.fileInputs[index].file = file
            this.$emit('filesImput', this.fileInputs)

            // Generar preview
            if (this.isImage(file)) {
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.$set(this.fileInputs[index], 'preview', e.target.result)
                }
                reader.readAsDataURL(file)
            } else if (this.isVideo(file)) {
                const videoURL = URL.createObjectURL(file)
                this.$set(this.fileInputs[index], 'preview', videoURL)
            }
        },

        isImage(file) {
            return file && file.type.startsWith('image/')
        },

        isVideo(file) {
            return file && file.type.startsWith('video/')
        },

        clearAllFiles(value = null) {
            this.fileInputs = [{
                file: null,
                preview: null
            }];

            if (value)
                this.$refs['fileInput0'][0].reset()
        }
    }
}
</script>

<style scoped>
.file-uploader {
    max-width: auto;
    margin: 0 auto;
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 8px;
}

.file-input-wrapper {
    margin-bottom: 15px;
    padding: 10px;
    border: 1px dashed #ccc;
    border-radius: 4px;
}

.file-input {
    display: block;
    margin-bottom: 10px;
}

.preview {
    margin-top: 10px;
}

.preview-image {
    display: block;
    margin: 0 auto;
    max-width: 100%;
    max-height: 100px;
}

.preview-video {
    display: block;
    margin: 0 auto;
    max-width: 100%;
    max-height: 200px;
}

.add-btn,
.upload-btn,
.remove-btn {
    padding: 8px 15px;
    margin-right: 10px;
    margin-top: 10px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.add-btn {
    background-color: #4CAF50;
    color: white;
}

.upload-btn {
    background-color: #2196F3;
    color: white;
}

.upload-btn:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
}

.remove-btn {
    background-color: #f44336;
    color: white;
}

.progress-bar {
    margin-top: 15px;
    width: 100%;
    height: 10px;
    background-color: #f1f1f1;
    border-radius: 5px;
    overflow: hidden;
}

.progress-bar div {
    height: 100%;
    background-color: #4CAF50;
    transition: width 0.3s;
}

.message {
    margin-top: 15px;
    padding: 10px;
    border-radius: 4px;
}

.message.error {
    background-color: #ffdddd;
    color: #f44336;
}
</style>